import moment from 'moment';
import React from "react";
import { useSelector } from 'react-redux';

const scaleMap = {
    million: 1_000_000,
    billion: 1_000_000_000
};
const universalSorter = (valueA, valueB, profile) => {
    const extractText = (val) => {
        if (React.isValidElement(val)) {
            val = val.props?.children ?? '';
        }
        if (Array.isArray(val)) {
            val = val.map(child => {
                if (React.isValidElement(child)) {
                    return child.props?.children ?? '';
                }
                return child;
            }).join(' ');
        }
        if (typeof val === 'number') return val;
        if (typeof val === 'string') {
            const trimmed = val.trim();
            if (profile?.dateFormate && moment(trimmed, profile.dateFormate, true).isValid()) {
                return moment(trimmed, profile.dateFormate, true).toDate().getTime();
            }
            const scaleMatch = trimmed.match(/(\d+(?:\.\d+)?)\s*(million|billion)/i);
            if (scaleMatch) {
                const number = parseFloat(scaleMatch[1]);
                const unit = scaleMatch[2].toLowerCase();
                return number * scaleMap[unit];
            }
            const cleaned = trimmed
                .replace(/^[^\d-]+/, '')
                .replace(/,/g, '')
                .replace(/\s+/g, '');
            const numberMatch = cleaned.match(/^(\d+(\.\d+)?)/);
            if (numberMatch) {
                return parseFloat(numberMatch[0]);
            }
            return trimmed.toLowerCase();
        }
        return '';
    };
    const a = extractText(valueA);
    const b = extractText(valueB);
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }
    return String(a).localeCompare(String(b), undefined, { numeric: true });
};
export const generateDynamicColumns = (checkboxValues, ViewDetailPage, sortedInfo, defaultCurrency) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    // const defaultWidth = 100;
    let columns = [];
    if (checkboxValues !== undefined) {
        columns = checkboxValues
            .filter((item) => item.isChecked)
            .map((item) => {
                const column = {
                    title: item.fieldType === "Currency" ? `${item.name} (${defaultCurrency?.currency})` : (item.fieldType === "Percentage" ? `${item.name} (%)` : item.name),
                    dataIndex: item.fieldKey,
                    key: item.fieldKey,
                    sortDirections: ['ascend', 'descend'],
                    sortOrder: sortedInfo?.column?.dataIndex === item.fieldKey ? sortedInfo?.order : null,
                };
                switch (item.fieldKey) {
                    case 'name':
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.name.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'accountName':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (record?.LinkAccount) {
                                    ViewDetailPage(record.accountID, "ACCOUNT")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.accountName.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children : '';
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'leadOwner':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (Role === "Administrator" || profile.userId === record.userId) {
                                    ViewDetailPage(record.userId, "USER")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.leadOwner.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    default:
                        column.sorter = (a, b) => {
                            const valueA = a[item.fieldKey]?.props?.children || '';
                            const valueB = b[item.fieldKey]?.props?.children || '';
                            return universalSorter(valueA, valueB, profile);
                        };
                        break;
                }
                return column;
            });
    }
    return columns;
}

export const generateUsersTableData = (exportData, checkboxValues, defaultCurrency) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const usersTableData = [];
    if (exportData && exportData[0] !== "") {
        exportData.forEach((lead, key) => {
            const customFields = {};
            lead.customFieldValues?.forEach((attr) => {
                const fieldConfig = checkboxValues.find(
                    (field) => field.id === attr.fieldId
                );
                if (!fieldConfig) return;
                let displayValue = attr.value;
                if (fieldConfig.fieldType === "Currency") {
                    displayValue = `${defaultCurrency?.symbol} ${Number(attr.value || 0)?.toLocaleString()}`
                } else if (fieldConfig.fieldType === "Percentage") {
                    displayValue = `% ${attr.value ?? "0"}`;
                } else if (
                    (fieldConfig.fieldType === "Dropdown" || fieldConfig.fieldType === 'Multi-Dropdown')
                ) {
                    displayValue = attr.option;
                }
                customFields[fieldConfig.fieldKey] = (
                    <div className="table_list_clicks">
                        {displayValue}
                    </div>
                );
            });
            usersTableData.push({
                LinkAccount: lead.accountPermission,
                accountID: lead.accountId,
                LeadDataForPermission: lead,
                SharingData: lead?.sharingPermission?.sharePermission,
                sharingid: lead.fromId,
                userId: lead.leadOwner,
                key: lead.leads_id,
                no: key + 1,
                name: (<div className="user-info_image table_list_clicks">
                    {lead.leads_id && (lead.leadProfile !== null && lead.leadProfile
                        !== undefined && lead.leadProfile !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={lead.leadProfile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag LeadIcon'>
                            {lead.firstName && lead.firstName.slice(0, 1).toUpperCase()}
                        </span>
                    )}
                    {lead.leads_id &&
                        <figcaption>
                            <div>
                                {`${lead.firstName} ${lead.lastName}`}
                            </div>
                            <div className='entityemail'>
                                {lead.primaryEmail}
                            </div>
                        </figcaption>
                    }
                </div>),
                accountName: (<div className={`user-info_image ${lead.accountPermission && "ListNavigate"}`}>
                    <span className='list_span_Tag AccountIcon'>
                        {lead?.accountName?.slice(0, 1).toUpperCase()}
                    </span>
                    <figcaption>
                        <div>
                            {lead.accountName}
                        </div>
                    </figcaption>
                </div>),
                primaryEmail: (<div className='table_list_clicks'>{lead.primaryEmail}</div>),
                leadStatusId: (lead.leadStatus && <div className={`table_list_clicks status-text Leadstatus${lead.leadStatus?.replace(/\s+/g, "")}`}>{lead.leadStatus}</div >),
                leadOwner: (<div className={`user-info_image ${(Role === "Administrator" || profile.userId === lead.leadOwner) && "ListNavigate"}`}>
                    {lead.leadOwner && (lead.userProfilePic !== null && lead.userProfilePic
                        !== undefined && lead.userProfilePic !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={lead.userProfilePic} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag UserIcon'>
                            {lead.userFirstName && lead.userFirstName.slice(0, 1).toUpperCase()}
                        </span>)
                    }
                    {lead.leadOwner &&
                        <figcaption>
                            <div>
                                {`${lead.userFirstName} ${lead.userLastName}`}
                            </div>
                            <div className='entityemail'>
                                {lead.leadOwnerMail}
                            </div>
                        </figcaption>}
                </div>
                ),
                title: (
                    <div
                        className='table_list_clicks'
                    >{lead.titleName}
                    </div>
                ),
                seniorityLevelId: (lead.seniorityLevel &&
                    <div
                        className='table_list_clicks'
                    >{lead.seniorityLevel}
                    </div>
                ),
                designation: (
                    <div
                        className='table_list_clicks'
                    >{lead.designation}
                    </div>
                ),
                secondaryEmail: (
                    <div
                        className='table_list_clicks'
                    >{lead.secondaryEmail}
                    </div>
                ),
                industry: (<div className='table_list_clicks'>{lead?.industryName}</div>),
                nomOfEmployees: (<div className='table_list_clicks'>{lead?.nomOfEmployeesName}</div>),
                annualRevenue: (<div className='table_list_clicks'>{lead?.annualRevenueName}</div>),
                rating: (<div className='table_list_clicks'>{lead?.ratingName}</div>),
                phone: (
                    <div
                        className='table_list_clicks'
                    >{lead.phone}
                    </div>
                ),
                fax: (
                    <div
                        className='table_list_clicks'
                    >{lead.fax}
                    </div>
                ),
                mobile: (
                    <div
                        className='table_list_clicks'
                    >{lead.mobile}
                    </div>
                ),
                leadSourceId: (lead.leadSource &&
                    <div className='table_list_clicks status-text LeadSource'
                    >{lead.leadSource}
                    </div>
                ),
                description: (
                    <div
                        className='table_list_clicks'
                    >
                        {lead.description ? `${lead.description.substring(0, 50)}...` : lead.description}
                    </div>
                ),
                emailOptOut: (
                    <div
                        className='table_list_clicks'
                    >{lead.emailOptOut === 0 ? "No" : lead.emailOptOut === 1 && "Yes"}
                    </div>
                ),
                country: (
                    <div
                        className='table_list_clicks'
                    >{lead.country}
                    </div>
                ),
                state: (
                    <div
                        className='table_list_clicks'
                    >{lead.state}
                    </div>
                ),
                city: (
                    <div
                        className='table_list_clicks'
                    >{lead.city}
                    </div>
                ),
                street: (
                    <div
                        className='table_list_clicks'
                    >{lead.street}
                    </div>
                ),
                postcode: (
                    <div
                        className='table_list_clicks'
                    >{lead.postcode}
                    </div>
                ),
                created_at: (
                    <div className='table_list_clicks'>
                        {lead?.created_at}
                    </div>
                ),
                modified_at: (
                    <div className='table_list_clicks'>
                        {lead?.modified_at}
                    </div>
                ),
                lead_score: (
                    <div className='table_list_clicks'>
                        {Number(lead?.lead_score)?.toFixed(2)}
                    </div>
                ),
                website: (
                    <div className='table_list_clicks'>
                        {lead?.website}
                    </div>
                ),
                linkedinUrl: (
                    <div className='table_list_clicks'>
                        {lead?.linkedinUrl}
                    </div>
                ),
                ...customFields,
            });
        });
    }
    return usersTableData;
};
